let ctx: AudioContext | null = null;

/** Three short beeps – audible in a loud gym without being annoying. */
export function beep() {
  try {
    ctx ??= new AudioContext();
    const start = ctx.currentTime;
    [0, 0.25, 0.5].forEach((offset, i) => {
      const osc = ctx!.createOscillator();
      const gain = ctx!.createGain();
      osc.frequency.value = i === 2 ? 1320 : 880;
      gain.gain.setValueAtTime(0.0001, start + offset);
      gain.gain.exponentialRampToValueAtTime(0.4, start + offset + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + offset + 0.18);
      osc.connect(gain).connect(ctx!.destination);
      osc.start(start + offset);
      osc.stop(start + offset + 0.2);
    });
  } catch {
    // ignore
  }
}

/** Must be called from a user gesture once so iOS allows audio later. */
export function unlockAudio() {
  try {
    ctx ??= new AudioContext();
    if (ctx.state === "suspended") void ctx.resume();
  } catch {
    // ignore
  }
}

export function vibrate(pattern: number | number[] = [200, 100, 200]) {
  if ("vibrate" in navigator) navigator.vibrate(pattern);
}
